import { useState } from "react";
import { FileUp, FileText, Loader2, X } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

export const PdfUpload = ({ value, name, onChange, testId = "pdf-upload" }) => {
  const [busy, setBusy] = useState(false);

  const pick = async (e) => {
    const f = e.target.files?.[0];
    e.target.value = "";
    if (!f) return;
    if (!f.name.toLowerCase().endsWith(".pdf")) return toast.error("Veuillez choisir un fichier PDF.");
    const fd = new FormData();
    fd.append("file", f);
    setBusy(true);
    try {
      const { data } = await api.post("/upload", fd);
      onChange(data.path, f.name);
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  if (value) return (
    <div className="flex items-center gap-3 rounded-xl border border-emerald-900/10 bg-white p-3">
      <FileText className="h-6 w-6 text-rose-600 shrink-0" />
      <span data-testid={`${testId}-name`} className="flex-1 min-w-0 truncate text-sm">{name || "Document PDF"}</span>
      <button type="button" data-testid={`${testId}-remove`} onClick={() => onChange(null, null)} className="rounded-full p-1 hover:bg-slate-100"><X className="h-4 w-4" /></button>
    </div>
  );

  return (
    <label className="flex items-center gap-3 rounded-xl border-2 border-dashed border-emerald-900/15 p-3 cursor-pointer hover:bg-emerald-50/50 transition-colors text-sm text-slate-600">
      {busy ? <Loader2 className="h-5 w-5 animate-spin text-emerald-700" /> : <FileUp className="h-5 w-5 text-emerald-700" />}
      Joindre un PDF (liste, programme, résultats…)
      <input type="file" accept="application/pdf,.pdf" data-testid={testId} className="hidden" onChange={pick} disabled={busy} />
    </label>
  );
};
